<template>
    <div>
        <b-card :header="uLang('app.edit')" header-tag="h4" class="bg-default-card">
            <trajectory-project-form :id="id"/>
        </b-card>
    </div>
</template>

<script>
    import TrajectoryProjectForm from '~/components/forms/admin/projects/trajectory-project/form'

    export default {
        name: 'edit',
        props: {
            id: {
                required: true,
            },
        },
        components: {
            'trajectory-project-form': TrajectoryProjectForm,
        },
    }
</script>

<style lang="css" scoped>
</style>